import { Station, useRouter } from '@mi-front/core';
import { ChipProps } from '@mui/material';
import { useStations } from '../../../core/stations/hooks/useStations';
import { useStationsStore } from '../../../core/stations/stores';
import { StationNavigator } from './StationNavigator';

interface StationNavigatorBreadcrumbProps {
  readonly basePath: string;
  readonly activeId: Station['id'];
  readonly size?: ChipProps['size'];
  readonly urlFn?: (basePath: string, station: Station) => string;
}

/**
 * Component that wraps StationNavigator and provides the station selection logic.
 * Handles URL generation and navigation when a station is selected.
 * Fetches stations and recent station IDs and passes them to StationNavigator.
 */
export const StationNavigatorBreadcrumb = (props: StationNavigatorBreadcrumbProps) => {
  const { history } = useRouter();
  const { basePath, urlFn } = props;

  const stations = useStations();
  const recentStationIds = useStationsStore((state) => state.recentStationIds);

  const handleSelectStation = (station: Station) => {
    const url = urlFn
      ? urlFn(basePath, station)
      : `/${basePath.replace(/^\//, '')}/s/${station.slug}`;

    history.push(url);
  };

  return (
    <StationNavigator
      activeId={props.activeId}
      size={props.size}
      onSelectStation={handleSelectStation}
      stations={stations}
      recentStationIds={recentStationIds}
    />
  );
};
